import UserInformation, { UserInformationProps } from './UserInformation';

export type { UserInformationProps };
export default UserInformation;
